/**
 * all states from store
 */
export default {
  menu_param: {},
  links: [],
  alcadas: [],
};
